import * as api from '../../api';
import * as flights from '../../flights';

export class AirportsFilterItem {
    checked: boolean;
    destination: api.Destination;

    constructor(checked: boolean, destination: api.Destination) {
        this.checked = checked;
        this.destination = destination;
    }
}

export class AirportsFilter {
    legs: {
        direction: string;
        departure: {
            items: AirportsFilterItem[];
        };
        arrival: {
            items: AirportsFilterItem[];
        };
    }[]

    constructor(flights: flights.FlightModel[]) {
        if (flights && flights.length) {
            this.legs = [];
            flights[0].legs.forEach((leg) => {
                this.legs.push({
                    direction: `${leg.departureDestination.city.localizedName} – ${leg.arrivalDestination.city.localizedName}`,
                    departure: {
                        items: []
                    },
                    arrival: {
                        items: []
                    }
                });
            });
        }

        flights.forEach((flight) => {
            flight.legs.forEach((leg, legIndex) => {
                const alreadyAddedDepartureItem = this.legs[legIndex].departure.items.find(x => x.destination.uniqueId == leg.departureDestination.uniqueId);

                if (!alreadyAddedDepartureItem) {
                    this.legs[legIndex].departure.items.push(new AirportsFilterItem(false, leg.departureDestination));
                }

                const alreadyAddedArrivalItem = this.legs[legIndex].arrival.items.find(x => x.destination.uniqueId == leg.arrivalDestination.uniqueId);

                if (!alreadyAddedArrivalItem) {
                    this.legs[legIndex].arrival.items.push(new AirportsFilterItem(false, leg.arrivalDestination));
                }
            });
        });

        this.legs.forEach((leg) => {
            const sortByLocalizedNameCallback = (a, b) => a.destination.localizedName == b.destination.localizedName ? 0 : (a.destination.localizedName > b.destination.localizedName ? 1 : -1);

            leg.departure.items.sort(sortByLocalizedNameCallback);
            leg.arrival.items.sort(sortByLocalizedNameCallback);
        });
    }

    get touched(): boolean {
        let touched = false;
        const legsWithCheckedItemIds = this.getLegsWithCheckedItemIds();

        legsWithCheckedItemIds.forEach((legWithCheckedItemIds) => {
            if (legWithCheckedItemIds.departure.length > 0
                || legWithCheckedItemIds.arrival.length > 0) {
                touched = true;
            }
        });

        return touched;
    }

    clear() {
        this.legs.forEach((leg) => {
            leg.departure.items.forEach((departureFilterItem) => {
                departureFilterItem.checked = false;
            });
            leg.arrival.items.forEach((arrivalFilterItem) => {
                arrivalFilterItem.checked = false;
            });
        });
    }

    check(flight: flights.FlightModel): boolean {
        let checkPassed = true;
        const legsWithCheckedItemIds = this.getLegsWithCheckedItemIds();

        flight.legs.forEach((leg, legIndex) => {
            if (legsWithCheckedItemIds[legIndex].departure.length
                && legsWithCheckedItemIds[legIndex].departure.indexOf(leg.departureDestination.uniqueId) < 0) {
                checkPassed = false;
            }
            if (legsWithCheckedItemIds[legIndex].arrival.length
                && legsWithCheckedItemIds[legIndex].arrival.indexOf(leg.arrivalDestination.uniqueId) < 0) {
                checkPassed = false;
            }
        });

        return checkPassed;
    }

    private getLegsWithCheckedItemIds() {
        const legsWithCheckedItems: {
            departure: number[];
            arrival: number[];
        }[] = [];

        this.legs.forEach((leg, legIndex) => {
            legsWithCheckedItems.push({
                departure: [],
                arrival: []
            });
            leg.departure.items.forEach((departureFilterItem) => {
                if (departureFilterItem.checked) {
                    legsWithCheckedItems[legIndex].departure.push(departureFilterItem.destination.uniqueId);
                }
            });
            leg.arrival.items.forEach((arrivalFilterItem) => {
                if (arrivalFilterItem.checked) {
                    legsWithCheckedItems[legIndex].arrival.push(arrivalFilterItem.destination.uniqueId);
                }
            });
        });

        return legsWithCheckedItems;
    }
}
